'use client';
import * as e from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const FormFieldContext = e.createContext(null);
FormFieldContext.displayName = 'FormFieldContext';
const useFormFieldContext = ()=>e.useContext(FormFieldContext);
const useNonNullishFormFieldContext = ()=>useNonNullishContext(FormFieldContext);
function useFormFieldProps(o) {
    let t = useFormFieldContext();
    if (e.useEffect(()=>{
        if (t) {
            let { setInputId: e } = t;
            return e(o), ()=>e(void 0);
        }
        return ()=>{};
    }, [
        t,
        o
    ]), null == t) return {
        id: o
    };
    let { errorIds: r, helperIds: i } = t;
    return {
        id: o,
        'aria-invalid': r.size > 0,
        'aria-errormessage': r.size > 0 ? [
            ...r
        ].join(' ') : void 0,
        'aria-describedby': r.size + i.size > 0 ? [
            ...i,
            ...r
        ].join(' ') : void 0
    };
}

export { FormFieldContext, useFormFieldContext, useFormFieldProps, useNonNullishFormFieldContext };
